import { createSlice } from '@reduxjs/toolkit';

const resetState = {
  userData: {},
  agent: null,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState: {
    ...resetState,
  },
  reducers: {
    setUserData: (reduxState, { payload = {} }) => {
      reduxState.userData = payload;
    },
    setAgent: (reduxState, { payload = null }) => {
      reduxState.agent = payload;
    },
    resetCurrentUserSlice: (reduxState) => {
      Object.assign(reduxState, resetState);
    },
  },
});

export const { setUserData, setAgent, resetCurrentUserSlice } = currentUserSlice.actions;

export { resetState as currentUserResetState };

export default currentUserSlice.reducer;
